import { useEffect, useState } from 'react'
import { API, graphqlOperation } from 'aws-amplify'

const query = `query GetRegistrationSettings($pk: ID!, $sk: String) {
    getRegistrationSettings(sk: $sk, pk: $pk) {
        phone
        pk
        sk
        workPhone
        userFields {
          label
          onRegistrationScreen
          advanced {
            numerical
            minLength
            unique
          }
          programReports {
            column
            search
          }
          required
          userList {
            column
            search
          }
          userReport {
            column
            search
          }
        }
        version
    }
  }`
  
const cache = {}

export const useGetRegistrationSettings = (pk, refetchTrigger = 0) => {
    const [data, setData] = useState(null)
    const [errors, setErrors] = useState(null)
    const [loading, setLoading] = useState(true)

    const handler = (_data) => {
        setLoading(false)
        setData(_data)
    }

    useEffect(() => {
        async function fetch() {
            // Clear cache when refetchTrigger changes
            if (refetchTrigger > 0 && cache[pk]) {
                delete cache[pk];
            }

            let cached = cache[pk]
            if (cached) handler(cached)

            try {
                const response = await API.graphql(graphqlOperation(query, { pk, sk: 'SETTINGS_REGISTRATION' }))
                cached = response.data.getRegistrationSettings
                cache[pk] = cached;
                handler(cached)
            } catch (response) {
                console.error(response)
                console.error(response.errors)
                setErrors(response.errors)
            }
        }

        if (pk) {
            fetch()
        } else {
            setErrors('Could not find a user with that email')
        }
    }, [pk, refetchTrigger])

    return { data, errors, loading }
}
